import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface LogoProps {
  dark?: boolean;
  to?: string;
}

export default function Logo({ dark = false, to = "#top" }: LogoProps) {
  const { t } = useTranslation();
  const inner = (
    <>
      <div className="relative w-12 h-12 shrink-0 flex items-center justify-center">
        <span className="font-heading font-bold text-4xl leading-none holo-text">M</span>
      </div>
      <div className="flex flex-col leading-none">
        <span
          className={`font-heading font-bold text-lg tracking-tight whitespace-nowrap ${
            dark ? "text-background-50" : "text-foreground-950"
          }`}
        >
          MEDIA<span className={dark ? "text-accent-300" : "text-primary-600"}>-STYLE</span>
        </span>
        <span
          className={`mt-1 text-[9px] uppercase tracking-[0.3em] whitespace-nowrap ${
            dark ? "text-background-50/60" : "text-foreground-500"
          }`}
        >
          {t("home.logo.tagline")}
        </span>
      </div>
    </>
  );

  const cls = "flex items-center gap-2.5 group";

  if (to.startsWith("#")) {
    return (
      <a href={to} className={cls}>
        {inner}
      </a>
    );
  }

  if (/^https?:\/\//i.test(to)) {
    return (
      <a href={to} className={cls}>
        {inner}
      </a>
    );
  }

  return (
    <Link to={to} className={cls}>
      {inner}
    </Link>
  );
}